import React from "react";
import Header from "./components/header";
import Footer from "./components/footer";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>iFLO Pro | Page Not Found</title>
      </Helmet>
      <Header />
      <div className="bg-[#0f0f0f] text-white min-h-screen flex items-center justify-center px-4">
        <div className="text-center">
          <h1 className="text-6xl font-bold mb-4">404</h1>
          <h2 className="text-2xl mb-6">Page Not Found</h2>
          <p className="mb-8">The page you are looking for doesn't exist or has been moved.</p>
          <a 
            href="/"
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-3 px-6 rounded-md transition"
          >
            Return Home
          </a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
